import type { SymmetryAxis } from "@pdfking/filling"

import type { LayoutDirection } from "../types/layout"

/** The direction whose children stand one after the other along the axis. */
export const ALONG_AXIS: Record<SymmetryAxis, LayoutDirection> = { x: "row", y: "column" }
